import apiCall from "../../utility/api";

interface PatchDetailsResponse {
    status: 'success' | 'failed';
    data?: PatchDetail[];
    error?: string;
  }
  
  interface PatchCountResponse {
    status: 'success' | 'failed';
    data?: {
      totalRecords: number;
      totalPages: number;
    };
    error?: string;
  }
  
  interface PatchMachineResponse {
    status: 'success' | 'failed';
    data?: MachineDetail[];
    error?: string;
  }
  
  interface PatchMachineCountResponse {
    status: 'success' | 'failed';
    data?: {
        totalRecords: number;
        totalPages: number;
      };
    error?: string;
  }

  interface PatchDetail {
    ptitle: string;
    ptype: string;
    patchdesc: string;
    psize: number;
    patch_count: number;
    detectedate: string;
  }
  
  interface MachineDetail {
    host: string;
    date: string;
  }

  interface MachineDetailsParams {
    title: any;
    tenant: string;
    type: 'normal' | 'filter' | 'search';
    filter?: string[];
    search?: string;
  }
  interface varValueParams {
    revl : string;
    valu : string;
    valueid : number;
  }
 export interface CheckDartResponse {
    status: 'success' | 'failed';
    data?:  varValueParams;
    error?: string;
  }

export const getPatchDetails = async (whereCondition: any, limit: number, offset: number): Promise<PatchDetailsResponse> => {
    try {
       return await apiCall(`/patchManagement/getPatchDetails`, { ...whereCondition, limit, offset });
    } catch (error) {
        console.log("getPatchDetails error=", error);
        return { data: null, status: 'failed' };
    }
}

export const getPatchDetailsCount = async (whereCondition: any, limit: number, offset: number): Promise<PatchCountResponse> => {
    try {
       return await apiCall(`/patchManagement/getPatchDetailsCount`, { ...whereCondition, limit, offset  });
    } catch (error) {
        console.log("getPatchDetailsCount error=", error);
        return { data: null, status: 'failed' };
    }
}

export const getPatchMachineDetails = async (whereCondition: MachineDetailsParams, limit: number, offset: number): Promise<any> => {
    try {
       return await apiCall(`/patchManagement/getPatchMachineDetails`, { ...whereCondition, limit, offset  });
    } catch (error) {
        console.log("getPatchMachineDetails error=", error);
        return { data: null, status: 'failed' };
    }
}

export const getPatchMachineDetailsCount = async (whereCondition: MachineDetailsParams, limit: number, offset: number): Promise<any> => {
    try {
       return await apiCall(`/patchManagement/getPatchMachineDetailsCount`, { ...whereCondition, limit, offset  });
    } catch (error) {
        console.log("getPatchMachineDetails error=", error);
        return { data: null, status: 'failed' };
    }
}

export const checkEnabledDart = async (params: any): Promise<CheckDartResponse> => {
    try {
       return await apiCall(`/patchManagement/checkEnabledDart`, params);
    } catch (error) {
        console.log("checkEnabledDart error=", error);
        return { data: null, status: 'failed' };
    }
}

export const updateDart = async (params: any): Promise<CheckDartResponse> => {
    try {
       return await apiCall(`/patchManagement/updateDartStatus`, params);
    } catch (error) {
        console.log("checkEnabledDart error=", error);
        return { data: null, status: 'failed' };
    }
}